import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router';

// environment
import {checkIsIntentApp} from '~/env';

// Polaris UI
import {AppProvider, Page} from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

// routes
import AppRoutesPlain from './routes';
import AppRoutesIntent from './routes/index-intent';

// styles
import '@shopify/polaris/build/esm/styles.css';

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
).render(
  <AppProvider i18n={enTranslations}>
    <Page>
      <BrowserRouter>
          {checkIsIntentApp() ? <AppRoutesIntent/> : <AppRoutesPlain/>}
      </BrowserRouter>
    </Page>
  </AppProvider>,
);
